import { Spin, Tooltip } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import accStatsIcon from "../../assets/icons/acc-stats.svg";
import plusIcon from "../../assets/icons/add_black_icon.svg";
import copyIcon from "../../assets/icons/copy-big.svg";
import crossIcon from "../../assets/icons/cross.svg";
import cross_iconnn from "../../assets/icons/cross_icon___.svg";
import done_icon from "../../assets/icons/done_icon.svg";
import profileIcon from "../../assets/icons/profile.png";
import viewIcon from "../../assets/icons/view-details.svg";
import ReactTable from "../../components/ReactTable/ReactTable";
import { cryptoNewCustomStyles, newCustomStyles } from "../../customstyle/customstyle";
import ErrorModal from "../../reusableComponents/ErrorModal";
import LoaderOverlay from "../../reusableComponents/Loader";
import Tabination from "../../reusableComponents/Tabination";
import { setActiveAccount } from "../../store/reducers/accountSlice";
import { baseUrl } from "../../utils/apis";
import "./style.scss";
import { formatUSD } from "../../utils/helpers/string";

function Dashboard() {
  const { data, error, loading, message, active } = useSelector((state) => state.account.accountList);
  const accountsData = useSelector((state) => state.account.accountMetrics);
  // console.log("accountsData", accountsData);
  const accountMetricsLoading = useSelector((state) => state.account.accountMetrics.loading);
  const idToken = useSelector((state) => state.auth.idToken);
  const { selectedBrand } = useSelector((state) => state.brand);

  // useEffect(() => {
  //   dispatch(getAccountMetrics({idToken, active}));
  // }, [active, idToken]);
  // const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const [errorModalOpen, setErrorModalOpen] = useState(error);
  const [isLoading, setIsLoading] = useState(error);
  const plansValue = useSelector((state) => state.account?.plans?.data || []);
  const proPlan = plansValue[1]?.challenges?.find((item) => item.name === "100K Challenge");
  const proPlan1 = plansValue[2]?.challenges?.find((item) => item.name === "100K Challenge");
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);
  const freeTril = [
    {
      text: "1:" + proPlan1?.leverage,
      icon: done_icon,
    },
    {
      text: `$${(proPlan1?.starting_balance / 100) * proPlan1?.max_daily_loss} (${proPlan1?.max_daily_loss}%) Max Daily Loss`,
      icon: done_icon,
    },
    {
      text: "EA",
      icon: `${proPlan1?.ea ? done_icon : cross_iconnn}`,
    },
    {
      text: `${proPlan1?.min_trading_days} Min Trading Days`,
      icon: done_icon,
    },
    {
      text: `${proPlan1?.profit_share}% Profit Split`,
      icon: done_icon,
    },
    {
      text: ` $${proPlan1?.starting_balance} Starting Balance`,
      icon: done_icon,
    },
  ];
  const freeTril1 = [
    {
      text: "1:" + proPlan?.leverage,
      icon: done_icon,
    },
    {
      text: `$${(proPlan?.starting_balance / 100) * proPlan?.max_daily_loss} (${proPlan?.max_daily_loss}%) Max Daily Loss`,
      icon: done_icon,
    },
    {
      text: "EA",
      icon: `${proPlan?.ea ? done_icon : cross_iconnn}`,
    },
    {
      text: `${proPlan?.min_trading_days} Min Trading Days`,
      icon: done_icon,
    },
    {
      text: `${proPlan?.profit_share}% Profit Split`,
      icon: done_icon,
    },
    {
      text: ` $${proPlan?.starting_balance} Starting Balance`,
      icon: done_icon,
    },
  ];

  const status = ["All", "Active", "Inactive"];

  useEffect(() => {
    setErrorModalOpen(error);
    setIsLoading(loading);
  }, [error, loading]);

  useEffect(() => {
    // dispatch(getAccountList(idToken));
  }, []);
  useEffect(() => {
    if (active == null) {
      data && dispatch(setActiveAccount({ login_id: data[0]?.login_id?.replace("%23", "#"), trading_platform: data[0]?.trading_platform, email: data && data[0]?.email }));
    } else return;
  }, [data]);

  const active_id = useSelector((state) => state.account.accountList);

  const navigate = useNavigate();

  const GroupIcon = (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="35"
        height="35"
        rx="17.5"
        fill="#ffffff"
      />
      <path
        d="M21.2365 17.2763L21.7127 17.8557L21.2365 17.2763ZM13.4563 17.2863L13.955 16.7261L13.4563 17.2863ZM18.6965 23.9243L18.2638 23.3118L18.6965 23.9243ZM16.9979 25.1243L17.4307 25.7369L16.9979 25.1243ZM10.6103 14.7521L10.1115 15.3122L10.6103 14.7521ZM24.3168 14.7446L23.8406 14.1651L24.3168 14.7446ZM21 13.875C21.4142 13.875 21.75 13.5392 21.75 13.125C21.75 12.7108 21.4142 12.375 21 12.375V13.875ZM14 12.375C13.5858 12.375 13.25 12.7108 13.25 13.125C13.25 13.5392 13.5858 13.875 14 13.875V12.375ZM12.6634 10.375H22.3862V8.875H12.6634V10.375ZM18.2638 23.3118L16.5652 24.5118L17.4307 25.7369L19.1293 24.5369L18.2638 23.3118ZM15.625 24.0742V20.419H14.125V24.0742H15.625ZM13.955 16.7261L11.109 14.192L10.1115 15.3122L12.9575 17.8464L13.955 16.7261ZM23.8406 14.1651L20.7603 16.6969L21.7127 17.8557L24.793 15.324L23.8406 14.1651ZM18.9375 20.5206V22.034H20.4375V20.5206H18.9375ZM20.7603 16.6969C19.608 17.644 18.9375 19.0417 18.9375 20.5206H20.4375C20.4375 19.4993 20.9002 18.5236 21.7127 17.8557L20.7603 16.6969ZM15.625 20.419C15.625 19.0099 15.0159 17.6708 13.955 16.7261L12.9575 17.8464C13.7047 18.5117 14.125 19.4457 14.125 20.419H15.625ZM19.1293 24.5369C19.9462 23.9598 20.4375 23.031 20.4375 22.034H18.9375C18.9375 22.5327 18.692 23.0093 18.2638 23.3118L19.1293 24.5369ZM16.5652 24.5118C16.1454 24.8083 15.625 24.4871 15.625 24.0742H14.125C14.125 25.7838 16.0834 26.6887 17.4307 25.7369L16.5652 24.5118ZM8.875 12.5764C8.875 13.6217 9.32682 14.6135 10.1115 15.3122L11.109 14.192C10.6381 13.7726 10.375 13.1858 10.375 12.5764H8.875ZM24.625 12.5282C24.625 13.1534 24.3418 13.7531 23.8406 14.1651L24.793 15.324C25.634 14.6327 26.125 13.6111 26.125 12.5282H24.625ZM22.3862 10.375C23.6433 10.375 24.625 11.3594 24.625 12.5282H26.125C26.125 10.4902 24.4304 8.875 22.3862 8.875V10.375ZM12.6634 8.875C10.5918 8.875 8.875 10.5118 8.875 12.5764H10.375C10.375 11.381 11.3789 10.375 12.6634 10.375V8.875ZM21 12.375L14 12.375V13.875L21 13.875V12.375Z"
        fill="#36D66B"
      />
    </svg>
  );

  const [filterData, setFilterData] = useState(data);

  const [params, setParams] = useState({
    active: undefined,
    _competition: null,
    phase: null,
    tab: null,
  });

  const DataFilterFunction = async () => {
    setIsLoading(true);
    let conditionalParams = {
      active: params.active,
      phase: selectedPhase?.value,
    };
    if (params._competition !== null && params._competition !== "") {
      // conditionalParams._competition = params._competition;
      conditionalParams.tab = params.tab;
    }

    let config = {
      headers: { Authorization: `Bearer ${idToken}` },
      params: {
        ...conditionalParams,
        ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
      },
    };

    //Test
    const response = await axios.get(`${baseUrl}/account/list/`, config);
    if (response.data) {
      setFilterData(response.data);
      setIsLoading(false);
    }
  };

  const [anchorElLive, setAnchorElLive] = React.useState(null);
  const [filterLive, setFilterLive] = useState("all");
  const openLive = Boolean(anchorElLive);
  const [live, setLive] = useState(false);

  const ActiveOption = [
    { label: "All", value: "False" },

    { label: "1 Step", value: "step_1" },
    { label: "2 Step", value: "step_2" },
  ];

  const handleClickLive = (event) => {
    setAnchorElLive(event.currentTarget);
  };
  const handleCloseLive = (values) => {
    setAnchorElLive(null);
    if (typeof values !== "object" || values === null) setFilterLive(values);
    if (values === "all") {
      setParams({ ...params, phase: "all" });
    } else if (typeof values !== "object") {
      setParams({ ...params, phase: values });
    }
  };

  // Phase wise Filtration

  const phaseOption = [
    {
      label: "All",
      value: null,
    },
    {
      label: "Stage 1",
      value: "stage_1",
    },
    {
      label: "Stage 2",
      value: "stage_2",
    },
    {
      label: "Funded",
      value: "funded",
    },
    ...(selectedBrand?.brand === "equity_edge"
      ? [
        {
          label: "Instant",
          value: "pro_edge",
        },
      ]
      : []),
  ];

  const [selectedPhase, setSelectedPhase] = useState(phaseOption[0]);

  const handlePhase = (selectedOption) => {
    setSelectedPhase(selectedOption);
    setCurrentPage(1);
  };

  // PlatformLinks
  const getMT5Link = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return {
        label: "MT5",
        value: "https://download.terminal.free/cdn/mobile/mt5/android?server=EquityEdge-Trade",
      };
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      return {
        label: "MT5",
        value: "https://download.terminal.free/cdn/mobile/mt5/ios?server=EquityEdge-Trade",
      };
    } else {
      return {
        label: "MT5",
        value: "https://download.terminal.free/cdn/web/equity.edge.ltd/mt5/equityedge5setup.exe",
      };
    }
  };

  const platformOption = [
    ...(selectedBrand?.brand === "equity_edge"
      ? [
        {
          label: "Match-Trader",
          value: "https://platform.equityedge.co.uk",
        },
        getMT5Link(),
      ]
      : []),
    ...(selectedBrand?.brand === "crypto_edge"
      ? [
        {
          label: "CE Terminal",
          value: "https://terminal.equityedge.co.uk/",
        },
      ]
      : []),
  ];

  // const filterPlatforms = (selectedBrand) => {
  //   console.log("selectedBrand", selectedBrand);
  //   if (selectedBrand?.brand === "crypto_edge") {
  //     return platformOption.filter((platform) => platform.label === "DxTrader");
  //   } else {
  //     return platformOption.filter((platform) => platform.label !== "DxTrader");
  //   }
  // };

  // const filteredPlatformOptions = filterPlatforms(selectedBrand);

  const [selectedPlatform, setSelectedPlatform] = useState(null);

  const handlePlatform = (selectedOption) => {
    if (selectedOption?.value) {
      window.open(selectedOption.value, "_blank");
    }
    setCurrentPage(1);
  };

  const [anchorElOne, setAnchorElOne] = React.useState(ActiveOption[0]);
  const [filterOne, setFilterOne] = useState("all");
  const openOne = Boolean(anchorElOne);
  const handleClickOne = (event) => {
    setAnchorElOne(event.currentTarget);
  };
  const [isLoginCopy, setIsLoginCopy] = useState(false);

  const handleCopyLogin = () => {
    setIsLoginCopy(true);
  };
  const handleCloseOne = (selectedOption) => {
    const { label, value } = selectedOption;
    setAnchorElOne(selectedOption);
    if (typeof value !== "object" || value === null) {
      setFilterOne(label);
    }
    if (label === "1 Step") {
      setLive(true);
      setParams({ ...params, phase: value, _competition: "" });
    } else if (label === "2 Step") {
      setLive(true);
      setParams({ ...params, phase: value, _competition: "" });
    } else if (label === "All") {
      setLive(false);
      setParams({ ...params, _competition: "", phase: "" });
    } else if (label === "Freetrial") {
      setLive(false);
      setParams({ ...params, phase: value });
    }
    //  else if (typeof value !== "object") {
    //   setParams({...params, [name]: value});
    // }
    if (label === "Competition") {
      setLive(false);
      setParams({ ...params, _competition: "False", tab: "competition" });
    }
  };

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  // console.log("currentPage", currentPage);

  const initialLoad = useRef(true);

  //

  const ActiveInctive = () => {
    if (!initialLoad.current) {
      if (activeTab === 0) {
        setParams({ ...params, active: undefined, phase: "" });
        setLive(false);
        setFilterOne("all");
      } else if (activeTab === 1) {
        setParams({ ...params, active: "True", phase: "" });
        setLive(false);
        setFilterOne("all");
      } else if (activeTab === 2) {
        setParams({ ...params, active: "False", phase: "" });
        setLive(false);
        setFilterOne("all");
      }
    } else {
      initialLoad.current = false;
    }
  };

  useEffect(() => {
    ActiveInctive();
  }, [activeTab]);

  useEffect(() => {
    DataFilterFunction();
  }, [params, selectedPhase, currentPage]);

  const items = [
    {
      name: "All",
      path: "",
    },
    {
      name: "Active",
      path: "",
    },
    {
      name: "Inactive",
      path: "",
    },
  ];

  const columns = useMemo(
    () => [
      {
        Header: "Login Id",
        accessor: "login_id",
        Cell: ({ row }) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{row.original.login_id?.replace("_", " ")}</span>
          </div>
        ),
      },
      { Header: "Trading Platform", accessor: "trading_platform", Cell: ({ value }) => <>{value?.toUpperCase()}</> },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => (
          <div
            className="status_wrapper"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <span
              className={`${row.original.status === "in_progress"
                ? "status status-progress"
                : row.original.status === "failed" || row.original.status === "expired"
                  ? "status-error status"
                  : row.original.status === "passed"
                    ? "status-passes status"
                    : row.original.status === "payout_requested"
                      ? "status status-progress"
                      : row.original.status === "disabled"
                        ? "status status-error"
                        : "status status-passes"
                }`}
            >
              {row.original.status?.replace("_", " ")}
            </span>
          </div>
        ),
      },
      { Header: "Challenge", accessor: "challenge" },
      // { Header: "Addon", accessor: "meta", Cell: ({ value }) => <>{value?.addon ? "YES" : "NO"}</> },
      { Header: "Plan Name", accessor: "plan_name", Cell: ({ value }) => <>{value?.replace("_", " ")}</> },
      { Header: "Phase", accessor: "phase", Cell: ({ value }) => <span style={{ textTransform: "capitalize" }}>{value?.replace("_", " ").replace("pro edge", "Instant")}</span> },
      { Header: "Start Date", accessor: "start_date", Cell: ({ value }) => <>{moment(value).format("DD-MM-YYYY")}</> },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ row }) => {
          const [accountInfoOpen, setAccountInfoOpen] = React.useState(false);
          const [accountMetricsOpen, setAccountMetricsOpen] = React.useState(false);

          return (
            <div className="action_btns">
              <Tooltip
                title="Account Info"
                color={selectedBrand?.brand === "equity_edge" ? "#35d269" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#35d269"}
                open={accountInfoOpen} // Control tooltip visibility
                onOpen={() => setAccountInfoOpen(true)} // Show on hover
                onClose={() => setAccountInfoOpen(false)} // Hide when hover ends or clicked
                enterDelay={0}
                leaveDelay={200}
              >
                <img
                  onClick={() => {
                    setIsModalOpen(true);
                    dispatch(
                      setActiveAccount({
                        login_id: row?.original?.login_id?.replace("#", "%23"),
                        trading_platform: row?.original?.trading_platform,
                        email: row?.original?.email,
                      }),
                    );
                    setAccountInfoOpen(false); // Close tooltip on click
                  }}
                  onMouseEnter={() => setAccountInfoOpen(true)} // Ensure hover works
                  onMouseLeave={() => setAccountInfoOpen(false)} // Ensure hover exit works
                  src={accStatsIcon}
                  alt="View Account Info"
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>

              <Tooltip
                title="Account Metrics"
                color={selectedBrand?.brand === "equity_edge" ? "#35d269" : selectedBrand?.brand === "crypto_edge" ? "#FCD535" : "#35d269"}
                open={accountMetricsOpen} // Control tooltip visibility
                onOpen={() => setAccountMetricsOpen(true)} // Show on hover
                onClose={() => setAccountMetricsOpen(false)} // Hide when hover ends or clicked
                enterDelay={0}
                leaveDelay={200}
              >
                <img
                  onClick={() => {
                    setAccountMetricsOpen(false);
                    dispatch(
                      setActiveAccount({
                        login_id: row?.original?.login_id?.replace("#", "%23"),
                        trading_platform: row?.original?.trading_platform,
                        email: row?.original?.email,
                      }),
                    );

                    setTimeout(() => {
                      navigate(`/account-metrics/program-objectives`);
                    }, 500);
                  }}
                  onMouseEnter={() => setAccountMetricsOpen(true)} // Ensure hover works
                  onMouseLeave={() => setAccountMetricsOpen(false)} // Ensure hover exit works
                  src={viewIcon}
                  alt="View Account Metrics"
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            </div>
          );
        },
      },
    ],
    [],
  );
  const handleCopyToClipboard = (text) => {
    toast(text || "Copied Transaction Id", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "success",
      theme: "dark",
      className: "custom-toast-container",
    });
  };

  const [accountCardData, setAccountCardData] = useState();
  // derive flagship plan and step from active account metrics (if present)
  const planName = accountsData?.data?.plan_name || "";
  const isFlagship = accountsData?.data?.challenge_type === "flagship" || /flagship/i.test(planName);
  const isTwoStepFlagship = isFlagship && /2\s*step/i.test(planName);
  return (
    <div className="dashboardContainer">
      <div className="dashboard">
        {errorModalOpen && (
          <ErrorModal
            desc={message}
            setModalOpen={setErrorModalOpen}
            btnText="Cancel"
          />
        )}
        {(isLoading || error) && <LoaderOverlay desc={error && message} />}

        <div
          className="dashboard_wrapper"
          style={{ height: "100%", width: "100%" }}
        >
          <div className="dashboard_top">
            <div className="dashboard_box">
              <div className="dashboard_table_inforamation">
                <div className="table_header">
                  <h2>Accounts</h2>
                  <div className="wrapperDashboard">
                    <div className="dashboard_nav_options">
                      <div className="dashboard_nav">
                        <Select
                          value={selectedPlatform}
                          options={platformOption}
                          onChange={handlePlatform}
                          placeholder="Platform Links"
                          // styles={newCustomStyles(40)}
                          styles={selectedBrand?.brand === "equity_edge" ? newCustomStyles(40) : selectedBrand?.brand === "crypto_edge" ? cryptoNewCustomStyles(40) : newCustomStyles(40)}
                          isSearchable={false}
                          className="tabination_var6"
                          classNamePrefix="react-select"
                        />
                      </div>

                      <div className="dashboard_nav">
                        <Tabination
                          variant={6}
                          tabItems={items}
                          activeTab={activeTab}
                          setActiveTab={setActiveTab}
                          isChart={true}
                          isToolbar={true}
                          cs={2}
                        />
                      </div>
                      <div className="dashboard_nav">
                        <Select
                          value={selectedPhase}
                          options={phaseOption}
                          onChange={handlePhase}
                          placeholder="Select Phase"
                          styles={selectedBrand?.brand === "equity_edge" ? newCustomStyles(40) : selectedBrand?.brand === "crypto_edge" ? cryptoNewCustomStyles(40) : newCustomStyles(40)}
                          className="tabination_var6"
                          classNamePrefix="react-select"
                          isSearchable={false}
                        />
                      </div>
                    </div>

                    <div className="add_acount_btn">
                      <Link to="/funding-evaluation/plans/0">
                        <div className="addAccount">
                          <img
                            src={plusIcon}
                            alt=""
                          />
                          <p>Choose Challenge</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <Table tableData={data} /> */}

                <ReactTable
                  data={filterData || []}
                  columns={columns}
                  loading={isLoading}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="modal_overlay"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="modal_content"
            onClick={(e) => e.stopPropagation()}
          >
            {accountMetricsLoading ? (
              <div className="accountInfo_loader_container">
                <Spin size="large" />
              </div>
            ) : (
              <>
                <div className="modal_header">
                  <div className="modal_header_profile">
                    <img
                      src={profileIcon}
                      alt=""
                    />

                    <div>
                      <h3>{accountsData?.data?.name?.split("-")[0] || "-"} </h3>
                      <span>
                        {accountsData?.data?.login_id || "-"}
                        <CopyToClipboard
                          onCopy={() => handleCopyToClipboard("Copied Login ID")}
                          text={accountsData?.data?.login_id}
                        >
                          {/* <button> */}

                          <img
                            src={copyIcon}
                            alt=""
                            height={"18px"}
                            width={"18px"}
                            className="cursorPointer"
                          />
                          {/* </button> */}
                        </CopyToClipboard>
                      </span>
                      <p style={{ textTransform: "capitalize" }}>{accountsData?.data?.phase?.replace("_", " ")?.replace("pro edge", "instant") || "-"}</p>
                    </div>
                  </div>
                  <div onClick={() => setIsModalOpen(false)}>
                    <img
                      src={crossIcon}
                      alt=""
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>

                <div className="modal_details">
                  <div className="details_list">
                    {selectedBrand?.brand === "crypto_edge" && (
                      <>
                        <div className="list_item">
                          <span className="title">Leverage(BTC/ETH)</span>
                          <p className="value">1:3</p>
                        </div>
                        <div className="list_item">
                          <span className="title">Leverage(ALT Coin)</span>
                          <p className="value">1:2</p>
                        </div>
                      </>
                    )}
                    {selectedBrand?.brand === "equity_edge" && (
                      <>
                        {isFlagship ? (
                          <>
                            <div className="list_item">
                              <span className="title">(Fx) Leverage</span>
                              <p className="value">{isTwoStepFlagship ? "1:100" : "1:50"}</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Indices) Leverage</span>
                              <p className="value">{isTwoStepFlagship ? "1:20" : "1:10"}</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Metals) Leverage</span>
                              <p className="value">{isTwoStepFlagship ? "1:30" : "1:10"}</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Oil) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Crypto) Leverage</span>
                              <p className="value">1:2</p>
                            </div>
                          </>
                        ) : accountsData?.data?.challenge_type === "pro_edge" ||
                          accountsData?.data?.challenge_type === "Instant" ||
                          accountsData?.data?.plan_name === "2 Step Swift Challenge" ||
                          accountsData?.data?.plan_name === "1 Step Swift Challenge" ? (
                          <>
                            <div className="list_item">
                              <span className="title">(Fx) Leverage</span>
                              <p className="value">1:30</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Indices) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Metals) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Oil) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Crypto) Leverage</span>
                              <p className="value">1:2</p>
                            </div>
                          </>
                        ) : /EE\s*Challenge/i.test(planName) ? (
                          <>
                            <div className="list_item">
                              <span className="title">(Fx) Leverage</span>
                              <p className="value">1:40</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Indices) Leverage</span>
                              <p className="value">{/2\s*step/i.test(planName) ? "1:15" : "1:10"}</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Metals) Leverage</span>
                              <p className="value">{/2\s*step/i.test(planName) ? "1:15" : "1:10"}</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Oil) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Crypto) Leverage</span>
                              <p className="value">1:2</p>
                            </div>
                          </>
                        ) : accountsData?.data?.challenge_type === "1_step" ? (
                          <>
                            <div className="list_item">
                              <span className="title">(Fx) Leverage</span>
                              <p className="value">1:40</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Indices) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Metals) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Oil) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Crypto) Leverage</span>
                              <p className="value">1:2</p>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="list_item">
                              <span className="title">(Fx) Leverage</span>
                              <p className="value">1:100</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Indices) Leverage</span>
                              <p className="value">1:15</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Metals) Leverage</span>
                              <p className="value">1:15</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Oil) Leverage</span>
                              <p className="value">1:10</p>
                            </div>
                            <div className="list_item">
                              <span className="title">(Crypto) Leverage</span>
                              <p className="value">1:2</p>
                            </div>
                          </>
                        )}
                      </>
                    )}

                    <div className="list_item">
                      <span className="title">Server</span>
                      <p className="value">{accountsData?.data?.server || "-"}</p>
                    </div>
                    <div className="list_item">
                      <span className="title">Challenge</span>
                      <p className="value">{accountsData?.data?.challenge || "-"}</p>
                    </div>
                    <div className="list_item">
                      <span className="title">Broker</span>
                      <p className="value">{accountsData?.data?.trading_platform?.toLowerCase() === "mt5" ? "Equity Edge LTD" : accountsData?.data?.server || "-"}</p>
                    </div>
                    <div className="line"></div>
                    <div className="list_item">
                      <span className="title">Investor Password</span>
                      <p className="value">
                        {accountsData?.data?.investor_password || "NA"}
                        {accountsData?.data?.investor_password && (
                          <CopyToClipboard
                            onCopy={() => handleCopyToClipboard("Copied Investor Password")}
                            text={accountsData?.data?.investor_password}
                          >
                            {/* <button> */}

                            <img
                              src={copyIcon}
                              alt=""
                              height={"18px"}
                              width={"18px"}
                              className="cursorPointer"
                            />
                            {/* </button> */}
                          </CopyToClipboard>
                        )}
                      </p>
                    </div>
                    <div className="list_item">
                      <span className="title">Master Password</span>
                      <p className="value">
                        {accountsData?.data?.password || "NA"}
                        {accountsData?.data?.password && (
                          <CopyToClipboard
                            onCopy={() => handleCopyToClipboard("Copied Password")}
                            text={accountsData?.data?.password}
                          >
                            {/* <button> */}

                            <img
                              src={copyIcon}
                              alt=""
                              height={"18px"}
                              width={"18px"}
                              className="cursorPointer"
                            />
                            {/* </button> */}
                          </CopyToClipboard>
                        )}
                      </p>
                    </div>
                    <div className="list_item">
                      <span className="title">Starting Balance</span>
                      <p className="value">{formatUSD(accountsData?.data?.starting_balance).replace(".00", "") || "-"}</p>
                    </div>
                    <div className="list_item">
                      <span className="title">Start Date</span>
                      <p className="value">
                        {accountsData?.data?.start_date
                          ? new Date(accountsData.data.start_date).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: false,
                          })
                          : "-"}
                      </p>
                    </div>
                    {accountsData?.data?.meta?.addon?.addons && (
                      <div className="list_item">
                        <span className="title">Add-Ons</span>
                        <p
                          style={{ textTransform: "capitalize" }}
                          className="value"
                        >
                          {/* {accountsData?.data?.meta?.addon?.addons ? accountsData?.data?.meta?.addon?.addons[0]?.key?.replace("_", " ") : "-"} */}
                          {accountsData?.data?.meta?.addon?.addons ? accountsData?.data?.meta?.addon?.title : "-"}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
